import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Select from 'react-select'
import FilterPagination from 'pages/parts/FilterPagination'
import FilterSearch from 'pages/parts/FilterSearch'
import { Dropdown } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

import { GET, httpOk } from 'helpers/api'
import { checkFilter, chequeDates, findKeyFromArrayByValue, formatDate, formatMoney, getCurrentChequeDate } from 'helpers/helpers'
import Rightbar from '../cheques/Rightbar'

function Sales() {
	const { t } = useTranslation()

	const date = new Date()
	const initialFilter = {
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		pos_id: null,
		search: ''
	};

	const [cashiers, setCashiers] = useState([])
	const [couriers, setCouriers] = useState([])
	const [categories, setCategories] = useState([])
	const [products, setProducts] = useState([])
	const [productTypes, setProductTypes] = useState([])
	const [data, setData] = useState([])
	const [cheque, setCheque] = useState({})

	const [showRightBar, setShowRightBar] = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({ ...initialFilter })
	const [pagination, setPagination] = useState({
		url: `/shifts/`,
		response: null
	})

	async function toggleRightBar(bool, item) {
		if (bool) {
			const response = await GET(`/cheques/${item.cheque_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setCheque(response.data)

			}
		}
		setShowRightBar(bool)
	}

	function resetFilter() {
		setFilterData({ ...initialFilter })
	}

	async function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result, 'dateType': option.id, page: 0 })
	}

	async function getData() {
		setFilterDataExist(checkFilter(filterData, initialFilter));

		const response = await GET("/report/sales", filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'response': response.data })
			if (dropdownIsOpen) setDropdownIsOpen(false)
		}
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	async function getCategories() {
		const response = await GET('/helper/categories')
		if (httpOk(response)) setCategories(response.data)
	}

	async function getProducts() {
		const response = await GET('/helper/all-products')
		if (httpOk(response)) setProducts(response.data)
	}

	async function getProductTypes() {
		const response = await GET('/helper/products-types')
		if (httpOk(response)) setProductTypes(response.data)
	}

	async function getCouriers() {
		const response = await GET('/helper/couriers')
		if (httpOk(response)) setCouriers(response.data)
	}

	async function getCashiers() {
		const response = await GET('/helper/cashiers')
		if (httpOk(response)) setCashiers(response.data)
	}

	useEffect(() => {
		getCategories()
		getProducts()
		getProductTypes()
		getCouriers()
		getCashiers()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		getData()
	}, [filterData.search, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('sales')} [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('categories')}</label>
												<Select
													options={categories}
													value={categories.find(option => option.id === filterData.category_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, category_id: option?.id, page: 0 })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
													isClearable
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('type')}</label>
												<Select
													options={productTypes}
													value={productTypes.find(option => option.id === filterData.product_type) || ''}
													onChange={(option) => setFilterData({ ...filterData, product_type: option?.id, page: 0 })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
													isClearable
												/>
											</div><div className="form-group col-md-6">
												<label>{t('products')}</label>
												<Select
													options={products}
													value={products.find(option => option.id === filterData.product_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, product_id: option?.id, page: 0 })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
													isClearable
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('cashiers')}</label>
												<Select
													options={cashiers}
													value={cashiers.find(option => option.login === filterData.cashier_login) || ''}
													onChange={(option) => setFilterData({ ...filterData, cashier_login: option?.login, page: 0 })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.login}
													isClearable
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('courier')}</label>
												<Select
													options={couriers}
													value={couriers.find(option => option.login === filterData.courier_login) || ''}
													onChange={(option) => setFilterData({ ...filterData, courier_login: option?.login, page: 0 })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.login}
													isClearable
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<Select
													options={chequeDates}
													value={chequeDates.find(option => option.id === filterData.dateType) || ''}
													onChange={(option) => selectChequeDates(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-4">
												<label className="invisible">{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd'), page: 0 })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd'), page: 0 })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>

										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => getData()}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>

						<div className="vertical-center">
							<h4 className="d-between" style={{ minWidth: '250px' }}>
								<b>{t('amount')}:</b>
								{formatMoney(data.total_amount)}
							</h4>
							<h4 className="d-between" style={{ minWidth: '250px' }}>
								<b>{t('metr')}:</b>
								{formatMoney(data.total_metr)}
							</h4>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
								{filterData.category_id &&
									<span className="me-2">
										<b>{t('categories')}: </b>
										{findKeyFromArrayByValue(categories, 'id', filterData.category_id, 'name')}
									</span>
								}
								{filterData.product_type &&
									<span className="me-2">
										<b>{t('type')}: </b>
										{findKeyFromArrayByValue(productTypes, 'id', filterData.product_type, 'name')}
									</span>
								}
								{filterData.product_id &&
									<span className="me-2">
										<b>{t('products')}: </b>
										{findKeyFromArrayByValue(products, 'id', filterData.product_id, 'name')}
									</span>
								}
								{filterData.cashier_login &&
									<span className="me-2">
										<b>{t('cashiers')}: </b>
										{findKeyFromArrayByValue(cashiers, 'login', filterData.cashier_login, 'name')}
									</span>
								}
								{filterData.courier_login &&
									<span className="me-2">
										<b>{t('courier')}: </b>
										{findKeyFromArrayByValue(couriers, 'login', filterData.courier_login, 'name')}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }}>#</th>
									<th style={{ 'width': '25%' }}>{t('name2')}</th>
									<th style={{ 'width': '15%' }}>{t('roll')}</th>
									<th style={{ 'width': '10%' }} className="text-center td-ellipsis">{t('open_date')}</th>
									<th style={{ 'width': '10%' }} className="text-center td-ellipsis">{t('close_date')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('size')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('metr')}</th>
									<th style={{ 'minWidth': '100px' }} className="text-end text-nowrap">{t('price')}</th>
									<th style={{ 'minWidth': '120px' }} className="text-end text-nowrap">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index} className="bg-on-hover" onClick={() => toggleRightBar(true, item)}>
										<td>{item.row_number}</td>
										<td className="td-ellipsis">{item.name}</td>
										<td className="td-ellipsis">{item.element_name}</td>
										<td className="text-center">{formatDate(item.cheque_opened_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className="text-center">{formatDate(item.cheque_closed_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className="text-end">{formatMoney(item.element_quantity, 2)}</td>
										<td className="text-end">{formatMoney(item.quantity, 2)}</td>
										<td className="text-end">{formatMoney(item.metr, 2)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.sale_price, 2)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.total_price, 2)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<Rightbar
				showRightBar={showRightBar}
				setShowRightBar={setShowRightBar}
				selectedItem={cheque}>
			</Rightbar>
		</>
	)
}

export default Sales